import confSystem from "@/components/Pages/Configuracoes/Sistema.vue"
import confPabx   from "@/components/Pages/Configuracoes/Pabx.vue"
import confRel    from "@/components/Pages/Configuracoes/Relatorio.vue"

export default [
	{
		name: "confSystem",
		path: ":get",
		component: confSystem,
		props: true
	},

	{
		name: "confPabx",
		path: ":get",
		component: confPabx,
		props: true
	},

	{
		name: "confRel",
		path: ":get",
		component: confRel,
		props: true
	}
]